import { render, staticRenderFns } from "./invest_qrcode.vue?vue&type=template&id=c4c0a0a0&scoped=true&"
import script from "./invest_qrcode.vue?vue&type=script&lang=js&"
export * from "./invest_qrcode.vue?vue&type=script&lang=js&"
import style0 from "./invest_qrcode.vue?vue&type=style&index=0&id=c4c0a0a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c0a0a0",
  null
  
)

export default component.exports